import { useRouter } from 'next/router'

import { usePagination } from './usePagination'

export const useSearch = () => {
  const router = useRouter()

  const { resetPagination } = usePagination()

  const setSearchQuery = (query: string) => {
    resetPagination()

    router.query.query = query
    router.push({ pathname: router.pathname, query: router.query }, undefined, {
      scroll: false
    })
  }

  const clearSearchQuery = () => {
    resetPagination()

    delete router.query.query
    router.push({ pathname: router.pathname, query: router.query }, undefined, {
      scroll: false
    })
  }

  return {
    searchQuery: (router.query.query as string) || '',
    setSearchQuery,
    clearSearchQuery
  }
}
